import { render } from "./MessageSnackbar.vue?vue&type=template&id=a19ef3ae"
import script from "./MessageSnackbar.vue?vue&type=script&lang=js"
export * from "./MessageSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__